import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgMessages = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 5.26997C1 4.01794 2.08414 3 3.41758 3H14.2967C15.6302 3 16.7143 4.01794 16.7143 5.26997V12.0799C16.7143 13.3319 15.6302 14.5238 14.2967 14.5238H8.65694L5.59341 16.5063C5.40831 16.634 5.16278 16.6553 4.95879 16.5595C4.75481 16.4638 4.62637 16.2687 4.62637 16.0523V14.5238H3.41758C2.08414 14.5238 1 13.3319 1 12.0799V5.26997Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M7.28571 16.2704C7.28571 16.0158 7.49203 15.8095 7.74655 15.8095H13.2C14.8802 15.8095 15.7202 15.8095 16.362 15.4825C16.9265 15.1949 17.3854 14.736 17.673 14.1715C18 13.5298 18 12.6897 18 11.0095V8.19047C18 7.63818 18.4477 7.19047 19 7.19047H20.5824C21.9159 7.19047 23 8.20841 23 9.46044V16.2704C23 17.5224 21.9159 18.5403 20.5824 18.5403H19.3736V20.2428C19.3736 20.4592 19.2452 20.6542 19.0412 20.75C18.8372 20.8458 18.5917 20.8245 18.4066 20.6968L15.3431 18.5403H9.70329C8.36984 18.5403 7.28571 17.5224 7.28571 16.2704Z", fill: props.fill }));
});
export default SvgMessages;
